<template>
  <div class="BasePannel" v-if="usermarkStore.showMarkDetail" :style="{ zIndex: currentZIndex }">
    <div class="BasePannel-title">
      <span>航标信息</span>
      <el-icon @click="usermarkStore.closeDetail" style="cursor: pointer" size="21">
        <CircleClose />
      </el-icon>
    </div>

    <div class="BasePannel-content">
      <el-descriptions :column="1" border>
        <el-descriptions-item label="航标名称">
          <h4>{{ usermarkStore.markDetail?.name }}</h4>
        </el-descriptions-item>
        <el-descriptions-item label="航标图片">
          <el-image
            style="height: 180px; width: 100%"
            :src="usermarkStore.markDetail?.photo"
            :zoom-rate="1.2"
            :max-scale="7"
            :min-scale="0.2"
            fit="cover"
            :preview-src-list="usermarkStore.markDetail ? usermarkStore.previewPhoto : []"
            show-progress
            preview-teleported
          />
        </el-descriptions-item>
        <el-descriptions-item label="航标类型">{{
          usermarkStore.markDetail?.structure
        }}</el-descriptions-item>
        <el-descriptions-item label="经度">{{
          usermarkStore.markDetail?.longitude
        }}</el-descriptions-item>
        <el-descriptions-item label="纬度">{{
          usermarkStore.markDetail?.latitude
        }}</el-descriptions-item>
        <el-descriptions-item label="所处航道">{{
          usermarkStore.markDetail?.navigationChannel
        }}</el-descriptions-item>
        <el-descriptions-item label="位置">{{
          usermarkStore.markDetail?.position
        }}</el-descriptions-item>
        <el-descriptions-item label="灯光特征">{{
          usermarkStore.markDetail?.lightCharacteristics
        }}</el-descriptions-item>
        <el-descriptions-item label="航标灯电压（伏）">{{
          usermarkStore.markDetail?.buoyRealData?.chVoltage || '-'
        }}</el-descriptions-item>
          <el-descriptions-item label="偏移（米）">{{
          Number(usermarkStore.markDetail?.distance).toFixed(1) || '-'
        }}</el-descriptions-item>
      </el-descriptions>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, watch, onMounted } from 'vue'
import { CircleClose } from '@element-plus/icons-vue'

import { useMarkStore } from '@/stores/navimark'
const usermarkStore = useMarkStore()

// 全局弹窗层级计数器
let currentZIndex = ref(10)

// 获取 .cesium-popup 的最大 z-index
const getCesiumPopupMaxZIndex = () => {
  const popups = document.querySelectorAll('.cesium-popup')
  let maxZIndex = 0
  popups.forEach((popup) => {
    const zIndex = parseInt(window.getComputedStyle(popup).zIndex || '0', 10)
    if (zIndex > maxZIndex) {
      maxZIndex = zIndex
    }
  })
  return maxZIndex
}

// 动态设置 BasePannel 的 z-index
const updateBasePannelZIndex = () => {
  const maxPopupZIndex = getCesiumPopupMaxZIndex()
  currentZIndex.value = maxPopupZIndex + 1
}

onMounted(() => {
  updateBasePannelZIndex()
})

watch(
  () => usermarkStore.markId,
  () => {
    updateBasePannelZIndex()
  }
)
</script>

<style lang="scss" scoped>
.BasePannel {
  width: 360px;
  position: absolute;
  top: calc(40px + 24px);
  right: 16px;
  bottom: 16px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  background-color: rgba(256, 256, 256, 0.5); /* 半透明背景 */
  backdrop-filter: blur(10px); /* 应用模糊效果 */
  border-radius: 6px;
  padding: 16px;
  &-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
    position: relative;
    > span {
      color: #000;
      font-weight: bold;
    }
  }

  &-content {
    flex: 1;
    height: calc(100% - 24px + 16px - 16px * 2);
    overflow: hidden;
    overflow-y: auto;

    ::-webkit-scrollbar {
      width: 8px; /* 滚动条宽度 */
      height: 8px; /* 横向滚动条高度 */
    }
    ::-webkit-scrollbar-track {
      background: #f1f1f1; /* 滚动条轨道背景色 */
    }

    ::-webkit-scrollbar-thumb {
      background: #ddd; /* 滚动条滑块背景色 */
      border-radius: 4px; /* 滚动条滑块圆角 */
    }

    ::-webkit-scrollbar-thumb:hover {
      background: #ccc; /* 滚动条滑块悬停背景色 */
    }

    ::-webkit-scrollbar-button {
      display: none; /* 隐藏滚动条按钮 */
    }
    scrollbar-width: thin; /* 设置滚动条宽度为细 */
    scrollbar-color: #ddd #f1f1f1; /* 滚动条滑块和轨道颜色 */
  }
}

:deep(.el-descriptions__cell) {
  font-size: 12px !important;
}
:deep(.is-bordered-label) {
  width: 45%;
}
</style>
